import type { Messages } from './en.js';

export const ru: Messages = {
  'app.title': 'Sync Port · передача файлов P2P',
  'secure.badge': 'Сквозное шифрование · напрямую между устройствами · ничего не хранится на серверах',
  'secure.tooltip':
    'Каналы данных WebRTC шифруются по DTLS между двумя устройствами. Сервер и TURN‑ретранслятор видят только зашифрованные данные.',
  'error.title': 'Связь потеряна',
  'error.peerFailed': 'Не удалось установить прямое соединение. Проверьте сеть или настройки TURN‑ретранслятора.',
  'error.signaling': 'Не удалось связаться с сервером сигнализации.',
  'error.roomNotFound': 'Нет открытой передачи с такой ссылкой или PIN‑кодом. Возможно, отправитель закрыл страницу или код введён с ошибкой.',
  'error.roomFull': 'Эту ссылку уже открыл кто‑то другой. Каждая ссылка работает только для одного получателя.',
  'notFound.tagline': 'В этой точке пространства пусто.',
  'notFound.text': 'Такой страницы не существует.',
  'notFound.action': 'Отправить файл',
  'action.startOver': 'Начать заново',
  'action.retry': 'Повторить',
  'action.cancel': 'Отмена',
  'action.dismiss': 'Закрыть',
  'sender.tagline': 'Передавайте файлы между устройствами по приватному зашифрованному каналу. Ничего не хранится на орбите.',
  'drop.title': 'Выберите файл для отправки',
  'drop.hint': 'Нажмите или перетащите файл сюда · любой размер',
  'share.title': 'Поделитесь этой ссылкой',
  'share.text': 'Откройте её на другом устройстве или отсканируйте код камерой телефона.',
  'share.linkLabel': 'Ссылка для получения',
  'share.copy': 'Копировать ссылку',
  'share.native': 'Поделиться…',
  'share.or': 'или',
  'share.pinHint': 'Введите этот PIN‑код на стартовой странице другого устройства.',
  'share.pinLabel': 'PIN‑код передачи',
  'share.copied': 'Скопировано в буфер обмена',
  'share.shared': 'Отправлено',
  'share.linkMessage': 'Откройте эту ссылку, чтобы получить файл от меня:',
  'share.unavailable': 'В этом браузере нет системного окна «Поделиться».',
  'clipboard.blocked': 'Браузер запретил копирование. Выделите ссылку и скопируйте её вручную.',
  'pin.title': 'Есть PIN‑код или QR‑код?',
  'pin.text': 'Введите 9‑значный код с отправляющего устройства или отсканируйте его QR‑код.',
  'pin.receive': 'Получить',
  'pin.scan': '📷 Сканировать QR‑код',
  'pin.incomplete': 'Введите все {count} цифр PIN‑кода.',
  'scan.hint': 'Наведите камеру на QR‑код на отправляющем устройстве',
  'scan.notOurs': 'Это не ссылка Sync Port. Найдите код на отправляющем устройстве.',
  'camera.denied': 'Доступ к камере запрещён. Разрешите его в настройках браузера или введите PIN‑код.',
  'camera.notFound': 'На этом устройстве не найдена камера.',
  'camera.busy': 'Камера занята другим приложением.',
  'camera.failed': 'Не удалось открыть камеру ({reason}).',
  'sender.status.creatingRoom': 'Создаём приватную комнату',
  'sender.status.waitingReceiver': 'Ждём, когда получатель откроет ссылку',
  'sender.status.receiverConnected': 'Получатель подключился, открываем зашифрованный прямой канал',
  'sender.status.waitingDestination': 'Зашифрованный канал открыт. Ждём, пока получатель выберет, куда сохранить',
  'sender.status.beaming': 'Передаём файл через космос',
  'sender.status.delivered': 'Доставлено',
  'status.failed': 'Передача не удалась',
  'progress.sending': 'Отправка',
  'progress.receiving': 'Получение',
  'progress.sentDetail': 'Отправлено {sent} · получатель подтвердил {acked}',
  'progress.deliveredDetail': 'Получатель принял весь файл.',
  'progress.arrivedDetail': 'Все байты получены.',
  'progress.of': '{done} из {total}',
  'progress.speedEta': '{speed} · осталось {eta}',
  'route.finding': 'Ищем лучший маршрут',
  'route.direct': 'Прямое соединение',
  'route.nat': 'Прямое соединение через NAT',
  'route.relay': 'Через TURN‑ретранслятор',
  'route.relayOver': 'Через TURN‑ретранслятор по {protocol}',
  'sender.sendAnother': 'Отправить ещё один файл',
  'receiver.tagline': 'Входящая передача по приватному зашифрованному каналу. Не закрывайте страницу, пока файл не будет получен.',
  'receiver.status.contacting': 'Связываемся с отправителем',
  'receiver.status.connected': 'Отправитель на связи, открываем зашифрованный прямой канал',
  'receiver.status.channelOpen': 'Зашифрованный канал открыт, ждём сведения о файле',
  'receiver.status.chooseDestination': 'Выберите, куда сохранить, чтобы начать получение',
  'receiver.status.receiving': 'Получение',
  'receiver.status.complete': 'Готово',
  'dest.title': 'Готовы к получению',
  'dest.picker.button': 'Выбрать, куда сохранить',
  'dest.picker.text': 'Входящий файл: {size}. Выберите место, и файл будет записываться прямо туда.',
  'dest.worker.button': 'Сохранить на это устройство',
  'dest.worker.text': 'Входящий файл: {size}. Он будет сразу записываться в папку «Загрузки».',
  'dest.memory.button': 'Получить файл',
  'dest.memory.text': 'Входящий файл: {size}. Этот браузер держит его во вкладке, пока вы не сохраните его после получения.',
  'dest.cancelled': 'Выберите место сохранения, чтобы начать получение.',
  'landed.title': 'Файл получен',
  'landed.chosenFolder': 'Сохранено как {name} в выбранной папке.',
  'landed.downloads': 'Сохранено в папку «Загрузки» браузера.',
  'landed.openWith': 'Открыть с помощью…',
  'landed.sendYourself': 'Отправить свой файл',
  'memory.received': 'Получено {size}. Сохраните файл на это устройство.',
  'memory.save': 'Сохранить файл',
  'memory.saved': 'Сохранено в папку «Загрузки» браузера. Файл можно сразу открыть в другом приложении.',
  'memory.saveAgain': 'Сохранить ещё раз',
  'error.inboxNotFound': 'Такого номера ящика не существует.',
  'error.inboxUnauthorized': 'Ключ не подходит к этому ящику.',
  'error.declined': 'Владелец ящика отклонил этот файл.',
  'error.inboxLimit': 'На этом сервере больше нельзя создавать ящики.',
  'home.inboxLink': 'Создать ящик',
  'inbox.tagline': 'Ваш постоянный ящик. Любой, кто отсканирует код, может предложить вам файл; вы решаете, что принять.',
  'inbox.create.title': 'Создать ящик',
  'inbox.create.text': 'Получите постоянный номер и QR‑код. Любой, кто его отсканирует, может предложить вам файл; ничего не придёт, пока вы не примете.',
  'inbox.create.button': 'Создать ящик',
  'inbox.connect.title': 'Уже есть ящик?',
  'inbox.connect.text': 'Вставьте секретный ключ, чтобы использовать ящик на этом устройстве. Номер необязателен: его можно найти по ключу.',
  'inbox.connect.numberOptional': 'Номер ящика (необязательно)',
  'error.keyUnknown': 'Ни один ящик не подходит к этому ключу.',
  'inbox.connect.number': 'Номер ящика',
  'inbox.connect.key': 'Секретный ключ',
  'inbox.connect.button': 'Подключить',
  'inbox.key.title': 'Ваш секретный ключ',
  'inbox.key.text': 'Сохраните номер и ключ вместе в надёжном месте. Ключ показывается только здесь и вместе с номером это единственный способ открыть ящик на другом устройстве.',
  'inbox.key.copy': 'Копировать номер и ключ',
  'inbox.key.copied': 'Номер и ключ скопированы',
  'inbox.key.done': 'Я всё сохранил',
  'inbox.number.title': 'Номер вашего ящика',
  'inbox.number.text': 'Распечатайте этот код или покажите на экране. Клиенты сканируют его или вводят номер на стартовой странице.',
  'inbox.status.connecting': 'Подключаемся к вашему ящику',
  'inbox.status.online': 'В сети. Ждём клиентов',
  'inbox.status.reconnecting': 'Связь потеряна. Переподключаемся',
  'inbox.requests.title': 'Входящие запросы',
  'inbox.requests.empty': 'Запросов пока нет. Они появятся здесь, как только клиент отправит файл.',
  'inbox.request.accept': 'Принять и сохранить…',
  'inbox.request.decline': 'Отклонить',
  'inbox.request.connecting': 'Принято. Подключаемся к клиенту',
  'inbox.request.cancelled': 'Клиент ушёл, не дождавшись ответа.',
  'inbox.refresh': 'Обновить',
  'inbox.forget': 'Забыть этот ящик на этом устройстве',
  'toInbox.tagline': 'Отправка файла в ящик {number}. Владелец увидит ваш запрос и примет решение.',
  'toInbox.status.announcing': 'Сообщаем ящику о вашем файле',
  'toInbox.status.waitingOnline': 'Запрос доставлен. Ждём подтверждения',
  'toInbox.status.waitingOffline': 'Владелец ящика сейчас не в сети. Запрос дождётся его возвращения',
  'toInbox.status.accepted': 'Принято. Открываем зашифрованный прямой канал',
  'inbox.print': 'Распечатать плакат (PDF)',
  'poster.title': 'Отправьте мне свои файлы',
  'poster.number': 'Номер ящика',
  'poster.step1': 'Отсканируйте код камерой телефона.',
  'poster.step2': 'Или откройте {link} и введите номер.',
  'poster.step3': 'Выберите файл. Мы примем его прямо здесь, у стойки.',
  'poster.footer': 'Sync Port · сквозное шифрование, напрямую между устройствами. Ничего не хранится на серверах.',
  'install.title': 'Установить Sync Port',
  'install.native': 'Добавьте на главный экран для быстрого доступа.',
  'install.ios': 'Нажмите «Поделиться», затем «На экран «Домой»».',
  'install.button': 'Установить',
};
